import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateLicenseTypeRequest, LicenseType, LicenseTypeResponse, UpdateLicenseTypeRequest } from '@models/csp';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LicenseTypesService {
  private readonly url = `${environment.bffUrl}/csp/license-types`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<LicenseType[]> {
    return this.httpClient.get<LicenseTypeResponse[]>(this.url);
  }

  add(req: CreateLicenseTypeRequest): Observable<LicenseType> {
    return this.httpClient.post<LicenseTypeResponse>(this.url, req);
  }

  update(id: string, req: UpdateLicenseTypeRequest): Observable<LicenseType> {
    return this.httpClient.put<LicenseTypeResponse>(`${this.url}/${id}`, req);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}`);
  }
}
